import React, { useRef, forwardRef, useImperativeHandle, useEffect } from "react";

const Table = forwardRef((props, ref) => {
    const containerRef = useRef(null);
    const lastScrollTop = useRef(0);

    // 👉 API pública para o componente pai
    useImperativeHandle(ref, () => ({
        scrollToTop() {
            if (containerRef.current) {
                containerRef.current.scrollTop = 0;
            }
        },
        scrollHorizontal(value, behavior = "smooth") {
            if (containerRef.current) {
                containerRef.current.scrollBy({ left: value, behavior });
            }
        },
        getScrollContainer() {
            return containerRef.current;
        },
    }));

    const onScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        const currentScrollTop = Math.max(el.scrollTop, 0);
        if (currentScrollTop === lastScrollTop.current) return;

        const down = currentScrollTop > lastScrollTop.current;
        lastScrollTop.current = currentScrollTop;

        if (props.handleScroll) {
            props.handleScroll(containerRef, down);
        }
    };

    // 👉 reage à prop scrollHorizontal
    useEffect(() => {
        if (!containerRef.current) return;
        if (!props.scrollHorizontal) return;

        containerRef.current.scrollBy({
            left: props.scrollHorizontal,
            behavior: props.scrollBehavior || "smooth",
        });
    }, [props.scrollHorizontal]);

    return (
        <div
            ref={containerRef}
            className={`custom-scroll ${props.responsive ? "table-responsive" : ""}`}
            style={{
                display: "flex",
                overflowX: props.scrollX || "auto",
                maxHeight: props.maxHeight || "70vh",
                height: props.height,
                minHeight: props.minHeight,
                minWidth: props.minWidth,
                maxWidth: props.maxWidth,
                overflowY: "auto",
                fontSize: props.fontSize,
                borderRadius: props.borderRadius,
                padding: props.padding,
            }}
            onScroll={onScroll}
        >
            <table id={props.id} className="table table-hover" style={{ border: props.tableBorder, margin: 0}}>
                {props.children}
            </table>
        </div>
    );
});

export default Table;
